.parentWrapper {
  padding: 20px;
  background-color: rgb(var(--ng-background-20));
  height: 100%;
  font-family: "Mulish", sans-serif;
}

.lead360GridWrapper {
  display: block;
}

.widgetWrapper {
  overflow: hidden;
  border-radius: var(--ng-rd-12);
  background-color: rgb(var(--ng-background-0));
  box-shadow: 0px 0px 6px 4px #1818180A;

  cursor: pointer;
}
